Namespace 'AccountSettings.OperatorStatus'

class AccountSettings.OperatorStatus.TimeoutEnabledCheckboxView extends Backbone.View
  template: JST["backbone/templates/account_settings/operator_statuses/timeout_enabled_checkbox"]

  events:
    "click .timeout-check": "onTimeoutCheck"

  initialize: (options) ->
    @checkboxID = options.id
    @enabled = false
    super

  render: =>
    @$el.html(@template(checkboxID: @checkboxID, enabled: @enabled))
    @delegateEvents()
    @

  onTimeoutCheck: =>
    @setCheckState(!@enabled)
    @trigger('timeout:enabled:changed', @enabled)
    @render()

  setCheckState: (state) =>
    @enabled = state

  hide: =>
    @$el.addClass('d-none')

  show: =>
    @$el.removeClass('d-none')
